import { db } from '@react-native-firebase/database';
import StyleSheetRW from 'core/StyleSheetRW';
import { get, push, ref, serverTimestamp, set } from "firebase/database";
import { useEffect, useState } from 'react';
import { Dimensions, ScrollView, Text, TouchableOpacity, View } from 'react-native';
import { MOBILE_VIEW_WIDTH } from 'res/constants';
import Dialog from 'src/components/Dialog';
import DropDownField from 'src/components/DropDownField';
import Loader from 'src/components/Loader';
import MultiSelect from 'src/components/MultiSelect';
import { YearOptions } from 'src/utils/DropDownOptionsUtils';
import closeIcon from "res/img/cross.png";
import { getCurrentDate } from 'src/utils/Date&TimeUtils';

interface AddCandidateFormProps {
  openForm: boolean
  editMode:boolean
  handleFormClose(): void
  handleFormSubmit():void
  editableReview:any
}
export const AddReviewAssignmentForm = ({ openForm, handleFormClose,handleFormSubmit, editableReview,editMode }: AddCandidateFormProps) => {
  const [showLoader, setShowLoader] = useState(false)
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const screenWidth = Dimensions.get('window').width;
  const [isVisible, setIsVisible] = useState(openForm)
  const [reviewsList,setReviewsList]=useState([])
  const [userList, setUserList] = useState([]);
  const [selectedReviewer, setSelectedReviewer] = useState(editMode===true?editableReview:null);
  const [selectedTobeReviewed, setSelectedTobeReviwed] = useState(editMode===true?editableReview:null);
  const [userRoles, setUserRoles] = useState([]);
  const [year,setReviewYear]=useState(editMode===true?editableReview.year:'2024');
  const [yearOption,setYearOption]=useState<String []>([])
  const [selectedRole, setSelectedRole] = useState(editMode===true?editableReview.ReviewerRole:'');
  const handleEditFormSubmit=async()=>
    {
        setShowLoader(true)
        if (!selectedReviewer || !selectedRole || !selectedTobeReviewed) {
          setToastMessage("Please Fill All the Fields");
          setShowToast(true);
          setSelectedRole("");
          setShowLoader(false)
          return;
        }
        try {
          const dbRef = ref(db, `questionnaire/${selectedRole}`);
          const snapshot = await get(dbRef);
        
          if (snapshot.exists()) {
            const resultObject = snapshot.val();
            console.log('Questions ', resultObject);
        
            const cleanedData = {};
            for (const key in resultObject) {
              if (Array.isArray(resultObject[key])) {
                const filteredArray = resultObject[key].filter(item => item.trim() !== '');
                if (filteredArray.length > 0) {
                  cleanedData[key] = filteredArray;
                }
              } else {
                cleanedData[key] = resultObject[key];
              }
            }
        
            console.log('Cleaned Questions ', cleanedData);
        
            
            const isCleanedDataEmpty = Object.keys(cleanedData).length === 0 || 
                                       Object.values(cleanedData).every(value => 
                                         Array.isArray(value) && value.length === 0
                                       );
        
            if (isCleanedDataEmpty) {
              setShowToast(true);
              setSelectedRole("");
              setToastMessage('No Questionnaire available in selected Role');
              setShowLoader(false);
              return;
            }
          } 
        } catch (error) {
          console.log("Error:", error);
          setShowLoader(false);
        }
        try {
          const dbRef = ref(db, `reviewAssignment/${editableReview.id}`);
          console.log(selectedReviewer,selectedTobeReviewed)
          var data= {
            ReviewerUserID: selectedReviewer.ReviewerUserID?selectedReviewer.ReviewerUserID:selectedReviewer.id,
            ReviewerUserName:selectedReviewer.ReviewerUserName?selectedReviewer.ReviewerUserName: `${selectedReviewer.firstName} ${selectedReviewer.lastName}`,
            ReviewedUserID: selectedTobeReviewed.ReviewedUserID? selectedTobeReviewed.ReviewedUserID:selectedTobeReviewed.id,
            ReviewedUserName:selectedTobeReviewed.ReviewedUserName?`${selectedTobeReviewed.ReviewedUserName}`:`${selectedTobeReviewed.firstName} ${selectedTobeReviewed.lastName}`,
            ReviewerRole: selectedRole,
            year:year,
            status:'In-Process',
            startDate:getCurrentDate(),
            dueDate:'',
          }   
          await set(dbRef, data);
          setShowToast(true);
          setToastMessage("Review Assignment Edited Successfully!");
          setShowLoader(false)
        } catch {
          setShowToast(true);
          setToastMessage("Error Updating Assignment of Review");
          setShowLoader(false)
        }
    }
  const handleSubmit = async () => {
    setShowLoader(true)
    if (!selectedReviewer || !selectedRole) {
      setToastMessage("Please Fill All the Fields");
      setShowToast(true);
      setSelectedRole("");
      setShowLoader(false)
      return;
    }

    // if (selectedReviewer.id === selectedTobeReviewed.id) {
    //   setToastMessage("Reviewer and The Person to be Reviewed cannot be same");
    //   setShowToast(true);
    //   setSelectedRole("");
    //   setShowLoader(false)
    //   return;
    // }
    try {
      const dbRef = ref(db, `questionnaire/${selectedRole}`);
      const snapshot = await get(dbRef);
    
      if (snapshot.exists()) {
        const resultObject = snapshot.val();
        console.log('Questions ', resultObject);
    
        const cleanedData = {};
        for (const key in resultObject) {
          if (Array.isArray(resultObject[key])) {
            const filteredArray = resultObject[key].filter(item => item.trim() !== '');
            if (filteredArray.length > 0) {
              cleanedData[key] = filteredArray;
            }
          } else {
            cleanedData[key] = resultObject[key];
          }
        }
    
        console.log('Cleaned Questions ', cleanedData);
    
        // Final check if cleanedData is empty
        const isCleanedDataEmpty = Object.keys(cleanedData).length === 0 || 
                                   Object.values(cleanedData).every(value => 
                                     Array.isArray(value) && value.length === 0
                                   );
    
        if (isCleanedDataEmpty) {
          setShowToast(true);
          setSelectedRole("");
          setToastMessage('No Questionnaire available in selected Role');
          setShowLoader(false);
          return;
        }
      } 
    } catch (error) {
      console.log("Error:", error);
      setShowLoader(false);
    }
    
    for (let index in reviewsList){
    try {
      const dbRef = push(ref(db, `reviewAssignment`));
      const singleReview=reviewsList[index]
      console.log('Single',singleReview)
     await set(dbRef, singleReview);
      setShowToast(true);
      setToastMessage("Review Assigned Successfully!");
      setShowLoader(false)
    } catch {
      setShowToast(true);
      setToastMessage("Error Assigning Review");
      setShowLoader(false)
    }}
  };
  const fetchUserRoles = async () => {
    setShowLoader(true)
    try {
      const dbRef = ref(db, `userRoles`);
      await get(dbRef).then((snapshot) => {
        if (snapshot.exists()) {
          console.log("Roles are ", snapshot.val());
          setUserRoles(snapshot.val());
        }
        setShowLoader(false)
      });
    } catch (error) {
      console.log("Error", error);
      setUserRoles([]);
      setShowLoader(false)
    }
  };
  const fetchUserData = async () => {
    setShowLoader(true)
    try {
      setUserList([]);
      const dbRef = ref(db, `profile`);
      await get(dbRef)
        .then((snapshot) => {
          if (snapshot.exists()) {
            const userFetchedData = snapshot.val();
            Object.keys(userFetchedData).forEach((userID) => {
              var userObj = userFetchedData[userID];
              if (userObj.userTypeId !== 1 && userObj.employmentStatus === "Active") {
                // not admin
                userObj.id = userID;
                userObj.title = userObj.firstName + " " + userObj.lastName;
                setUserList((prevUserList) => [...prevUserList, userObj]);
              }
            });
            console.log("userList", userList);
            setShowLoader(false)
          } else {
            console.log("No data available for the specified date.");
            setShowLoader(false)
          }
        })
        .catch((error) => {
          console.error("Failed to retrieve data:", error);
          setShowLoader(false)
        });
    } catch (error: any) {
      console.error("Error reading data:", error.message);
      setShowLoader(false)
    }
  };

  const handleAddReview =() => {
    setShowLoader(true)
        if (!selectedReviewer || !selectedRole || !selectedTobeReviewed||!year) {
      setToastMessage("Please Fill All the Fields");
      setShowToast(true);
      setShowLoader(false)
      return;
    }

    if (selectedReviewer.id === selectedTobeReviewed.id) {
      setToastMessage("Reviewer and The Person to be Reviewed cannot be same");
      setShowToast(true);
      setShowLoader(false)
      return;
    }
    const reviewObject = {
      ReviewerUserID: selectedReviewer.id,
      ReviewerUserName: `${selectedReviewer.firstName} ${selectedReviewer.lastName}`,
      ReviewedUserID: selectedTobeReviewed.id,
      ReviewedUserName: `${selectedTobeReviewed.firstName} ${selectedTobeReviewed.lastName}`,
      ReviewerRole: selectedRole,
      year:year,
      status:'In-Process',
      startDate:getCurrentDate(),
      dueDate:'',
    };
  
    // if(reviewObject.ReviewedUserID===reviewObject.ReviewerUserID)
    //   {
    //     setShowLoader(false)
    //     setShowToast(true)
    //     setToastMessage('Reviewer and the User to be Reviewed cannot be same')
    //     return
    //   }
    // Check if the review already exists
    const isDuplicate = reviewsList.some(review => {
      return (
        review.ReviewerUserID === reviewObject.ReviewerUserID &&
        review.ReviewedUserID === reviewObject.ReviewedUserID
      );
    });
  
    if (!isDuplicate) {
      console.log('List is ', reviewsList);
      const addToReviewList = [...reviewsList, reviewObject];
      console.log('List is ', addToReviewList);
      setReviewsList(addToReviewList);
      setShowLoader(false)
      return
    } else {
      setToastMessage("Review is Already Added");
      setShowToast(true);
      setShowLoader(false)
      return;
    }
  };


  const handleMultiSelect=(selectedItems:any)=>
   {
    if(selectedItems.length===0)
      {
        return;
      }
    if(!selectedReviewer&&selectedItems.length>0)
      {
        setShowToast(true)
        setToastMessage('Please Fill the Role, and Reviewer')
        return;
      }
    console.log(selectedReviewer)
   console.log('Selected Items are ',selectedItems)
   const addToReviewList = [];
for (const x in selectedItems)
  {
//     if(selectedReviewer.id===selectedItems[x].id)
// {
//   break;
// }

      console.log('To be Reviewed',selectedItems[x])
     const reviewObject = {
      ReviewerUserID: selectedReviewer.id,
      ReviewerUserName: `${selectedReviewer.firstName} ${selectedReviewer.lastName}`,
      ReviewedUserID: selectedItems[x].id,
      ReviewedUserName: `${ selectedItems[x].firstName} ${ selectedItems[x].lastName}`,
      ReviewerRole: selectedRole,
      year:year,
      status:'In-Process',
      startDate:getCurrentDate(),
      dueDate:'',
    };
    const isDuplicate = addToReviewList.some(review => {
      return (
        review.ReviewerUserID === reviewObject.ReviewerUserID &&
        review.ReviewedUserID === reviewObject.ReviewedUserID
      );
    });
    if(!isDuplicate){
    addToReviewList.push(reviewObject)}
  }
console.log('LIST',addToReviewList)
 setReviewsList(addToReviewList)

   }
   const fetchQuestions = async () => {
    try {
      setShowLoader(true);
      const dbRef = ref(db, `questionnaire/${selectedRole}`);
      const snapshot = await get(dbRef);
      if (snapshot.exists()) {
        const resultObject = snapshot.val();
        console.log('Questions ',resultObject);
        const cleanedData = {};
        for (const key in resultObject) {
          if (Array.isArray(resultObject[key])) {
            const filteredArray = resultObject[key].filter(item => item.trim() !== '');
            if (filteredArray.length > 0) {
              cleanedData[key] = filteredArray;
            }
          } else {
            cleanedData[key] = resultObject[key];
          }
        }
  
        console.log('Cleaned Questions ', cleanedData);
    
      }
      else
      {
       
        setToastMessage('No Questionnaire available in selected Role')
        setShowLoader(false)
      }
    } catch (error) {
      console.log("Error:", error);
      setShowLoader(false);
    }
  };
useEffect(()=>
{
  const fetchedYearOptions=YearOptions();
  setYearOption(fetchedYearOptions)
    console.log('Review',editableReview)
fetchUserData()
fetchUserRoles()
},[])

  return (
    <>
      <Dialog
        message={toastMessage}
        isDialogVisible={showToast}
        onDialogClose={() => {
          setShowToast(false)
          if(toastMessage.includes('Review Assigned Successfully!')||toastMessage.includes('Review Assignment Edited Successfully!'))
        { handleFormSubmit()}
          else if(toastMessage.includes('Error'))
          {
            handleFormClose()
          }
        }
        }
        title="Assign Review"
        confirmText="Close"
      />
      {
        showLoader && <Loader />
      }
      {isVisible && <View style={{ position: "absolute", zIndex: 1, top: 0, left: 0, right: 0, bottom: 0, justifyContent: "center", alignItems: "center", overflow: "hidden", }}>
        <View style={{ flex: 1, width: "100%", height: "100%" }}>
          <ScrollView showsVerticalScrollIndicator={false} style={{ ...styles.Container, paddingTop: screenWidth <= MOBILE_VIEW_WIDTH ? "10px" : "20px", height: "550px",marginLeft:screenWidth<MOBILE_VIEW_WIDTH?0:270,width:'80%' }}>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <Text style={styles.heading}>{editMode===true?'Edit Review Assignment':'Add Review Assignment'}</Text>
             
              <img src={closeIcon} alt="Close"    style={{ right: 10, position: "absolute", top: 5, cursor: "pointer", width:13,height:13 }}          onClick={handleFormClose}/>
              
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Reviewer*</Text>
              <DropDownField
              isObjectList={true}
              value={selectedReviewer?.ReviewerUserName}
              placeholder="Select Reviewer"
              bodyStyle={{ marginHorizontal: 0 }}
              options={userList}
              onChangeText={(selectedObj) => setSelectedReviewer(selectedObj)}
              label="Reviewer"
            />
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Reviewer Role*</Text>
              <DropDownField
              value={selectedRole}
              placeholder="Select Role"
              bodyStyle={{ marginHorizontal: 0 }}
              options={userRoles}
              onChangeText={(selectedObj) => setSelectedRole(selectedObj)}
              label="Role"
            />
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Reviewed*</Text>
         {editMode===false&&     <MultiSelect
              isObjectList={true}
              options={userList}
              onChangeText={(obj)=>handleMultiSelect(obj)}
              onSubmit={handleSubmit}
             label="User(s) To be Reviewed"
           
              />}
              {
                editMode===true&&
                <DropDownField
                isObjectList={true}
                value={selectedTobeReviewed.ReviewedUserName?selectedTobeReviewed.ReviewedUserName:`${selectedTobeReviewed.firstName} ${selectedTobeReviewed.lastName}`}
                placeholder="Select Reviewer"
                bodyStyle={{ marginHorizontal: 0 }}
                options={userList}
                onChangeText={(selectedObj) => setSelectedTobeReviwed(selectedObj)}
                label="Reviewer"
              />
              }
            </View>
            <View style={styles.container2}>
              <Text style={[styles.label, { marginTop: 0 }]}>Year</Text>
              <DropDownField
              isObjectList={false}
              value={year}
              placeholder="Select Year"
              bodyStyle={{ marginHorizontal: 0 }}
              options={yearOption}
              onChangeText={(selectedObj) => setReviewYear(selectedObj)}
              label="Reviewer"
            />
            </View>
            <View style={{flexDirection:'row',justifyContent:'space-evenly',alignItems:'center'}}>
            <TouchableOpacity
              style={{ marginTop:20,backgroundColor: '#2F4858',width:147, borderRadius: 20, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', paddingVertical: 10 }}
              onPress={editMode===true?handleEditFormSubmit:handleSubmit}
            >
              <Text style={{ color: 'white', cursor: "pointer" }}>Save</Text>
            </TouchableOpacity>
            </View>
          </ScrollView>
        </View>
      </View>}
    </>
  );
};

const styles = StyleSheetRW.create(() => ({
  container2: { display: "flex", flexDirection: "column", marginTop: 18 },
  Container: {
    position: "absolute",
    top: "10px",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#ffffff",
    borderRadius: 24,
    opacity: 1,
    transition: "opacity 0.3s ease",
    zIndex: 1,
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    width: "299px",
    alignSelf: "center",
  },
  heading: {
    fontFamily: "Outfit",
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    color: "#333333",
  },
  label: {
    fontFamily: "Outfit",
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 17.64,
    textAlign: "left",
    width: "100%",
    marginTop: 10,
    marginBottom: 5,
    color: "#333333",
  },
  input: {
    height: 50,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: "#0000000D",
    marginTop: 3,
  },
  button: {
    backgroundColor: "#2F4858",
    alignSelf: "center",
    borderRadius: 100,
    color: "white",
    fontWeight: "300",
    textAlign: "center",
    borderWidth: 0,
    width: "250px",
    height: "38px",
    cursor: "pointer",
  },
  buttoneStyle: {
    backgroundColor: "#8c9ea2",
    borderRadius: 99,
    fontWeight: "lighter",
    fontSize: "14px",
    color: "white",
    width: "110px",
    height: "37px",
    border: "0",
    cursor: "pointer",
  },
}));
